<pk-broker-modal customBodyClass="pb-0" customFooterClass="justify-content-center">
	<ng-template #headerTemplate>
		<h5 class="modal-title">Generate {{ poaAttachmentName }}</h5>
	</ng-template>
	<ng-template #bodyTemplate>
		<div class="container-fluid">
			<div class="row">
				<div class="col-4">
					<label>{{ poaAttachmentName }}</label>
				</div>
				<div class="col-8">
					<div class="row">
						<div class="col-4 form-element-container">
							<label class="custom-control-label" for="addLOASend">{{ latestLoaSentDate ? 'Resend ' : 'Send' }}</label>
							<p class="smaller-text" *ngIf="latestLoaSentDate">Last Sent On {{ latestLoaSentDate | date: 'MM/dd/yyyy' }}</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</ng-template>

	<ng-template #footerTemplate>
		<button type="button" class="btn btn-link" (click)="close()" [disabled]="submitDisabled">Cancel</button>
		<button type="button" class="btn btn-primary" (click)="submit()" [disabled]="submitDisabled">{{ submitText }}</button>
	</ng-template>
</pk-broker-modal>
